import type {Point} from '@yandex-delivery/core/types'
import type {Brand} from '@yandex-delivery/express/utils'
import type {Country} from '@yandex-delivery/types'

export type AppConfig = {
  config: {
    dir: 'rtl' | 'ltr'
    lang: string
    countries: Record<string, Country>
    detectedCountry: string
    basename?: string
    b2bApiHost?: string
    mapLang: string
    location: Point
    branding: Brand
    version: string
    yaAuthProxyHost: string
  }
  i18n: Record<string, unknown>
}

export const __NAME__ = '__TARIFFS_CONFIG__'
